import { ref } from 'vue'

const currentMonth = ref(new Date().getMonth() + 1)

export const useMonthSelector = () => {
  const setMonth = month => {
    currentMonth.value = month
  }

  return { currentMonth, setMonth }
}
